import "./collapsible.scss"

export default function setListeners() {
  ;[...document.querySelectorAll(".collapsible")].forEach((container) => {
    const maxHeight = parseInt(container.dataset.maxHeight, 10)
    if (!maxHeight || container.offsetHeight <= maxHeight) return

    const content = container.querySelector(".collapsible__content")
    if (!content) return

    const toggle = document.createElement("a")
    toggle.href = "#"

    function update(collapsed) {
      if (collapsed) {
        toggle.innerText = "Read More"
        content.style.height = `${maxHeight}px`
      } else {
        toggle.innerText = "Read Less"
        content.style.height = "auto"
      }
    }

    let collapsed = true
    update(collapsed)

    toggle.addEventListener("click", (e) => {
      e.preventDefault()
      e.stopPropagation()

      collapsed = !collapsed
      update(collapsed)
    })

    container.appendChild(toggle)
  })
}
